import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeModal } from '../store/slices/modalSlice';
import { useI18n } from '../i18n/I18nContext';
import styles from './Modal.module.css';

function Modal() {
  const dispatch = useDispatch();
  const { t } = useI18n();
  const { isOpen, title, message } = useSelector((state) => state.modal);

  if (!isOpen) return null;

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleBackdropClick}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
        </div>
        <div className={styles.modalBody}>
          <p className={styles.modalMessage}>{message}</p>
        </div>
        <div className={styles.modalFooter}>
          <button className={styles.confirmButton} onClick={handleClose}>
            {t('modal.confirm')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
